import { JetView } from "webix-jet";
import { getInfoList } from "../../helpers/infolist";
import { roleAvatar } from "../../helpers/templates";

export default class UsersView extends JetView {
	config() {
		const padding = { left: 10 };
		const headers = {
			view: "toolbar",

			padding,
			cols: [
				{ view: "label", label: "Role information" },
				{
					view: "icon",
					icon: "wxi-pencil",
					click: () => this.Edit(this.ID),
				},
			],
		};

		const details = {
			view: "template",
			localId: "title",
			autoheight: true,
			template: this.TitleTemplate,
		};

		const info = {
			localId: "info",
			template: " ",
			scroll: true,
			onClick: {
				webix_um_infolist_users_name: e => {
					let id = webix.html.locate(e, "data-id");
					this.app.callEvent("details:item-click", ["users", id]);
				},
				webix_um_infolist_rules_name: e => {
					let id = webix.html.locate(e, "data-id");
					this.app.callEvent("details:item-click", ["rules", id]);
				},
			},
		};

		return {
			localId: "layout",
			maxWidth: 350,
			rows: [
				headers,
				{
					type: "clean",
					rows: [details, info],
				},
			],
		};
	}

	urlChange() {
		if (!this.Compact) this.SetValues();
	}

	SetValues() {
		this.ID = this.getParam("id", true);
		const local = this.app.getService("local");
		const roles = local.roles(true);
		roles.waitData.then(() => {
			const role = roles.getItem(this.ID);
			// called outside Promise.all to display role title faster
			this.SetTitle(role);
			Promise.all([local.rules(), local.users()]).then(data => {
				this.SetDetails(role, data[0], data[1]);
			});
		});
	}
	SetTitle(role) {
		this.$$("title").setValues({ color: role.color, name: role.name });
	}
	TitleTemplate(role) {
		return (
			roleAvatar(role, "webix_um_avatarbox_roles") +
			`<div class='webix_um_title'>${role.name ? role.name : ""}</div>`
		);
	}

	SetDetails(role, allRules, allUsers) {
		this.$$("info").setHTML(this.GetDetailsHTML(role, allRules, allUsers));
	}

	GetDetailsHTML(role, allRules, allUsers) {
		return this.GetListsHTML(role, allRules, allUsers);
	}
	GetListsHTML(role, allRules, allUsers) {
		const _ = this.app.getService("locale")._;
		let assigned = this.GetAssignments(role, allRules, allUsers);
		return getInfoList([
			{
				name: "rules",
				data: assigned.rules,
				key: "long",
				title: _("Rules assigned"),
				icon: "umi-rules",
			},
			{
				name: "users",
				data: assigned.users,
				key: "name",
				title: _("Members assigned"),
				icon: "umi-users",
			},
		]);
	}

	GetAssignments(role, allRules, allUsers) {
		let assigned = {};
		assigned.rules = this.GetRoleRules(role, allRules);
		assigned.users = this.GetRoleMembers(role, allUsers);
		return assigned;
	}

	GetRoleRules(role, rules) {
		const rIds = role.rules || [];
		let data = [];
		rIds.forEach(id => {
			data.push(rules.getItem(id));
		});
		return data;
	}

	GetRoleMembers(role, users) {
		let roleUsers = [];
		users.data.each(user => {
			if (user.roles && user.roles.indexOf(role.id) > -1) roleUsers.push(user);
		});
		return roleUsers;
	}

	Edit(id) {
		this.show(`../../roles?id=${id}/roles.editor`);
	}
}
